function hasPositiveNumber(value: unknown) {
  const num = Number(value);
  return Number.isFinite(num) && num > 0;
}

/** 从隐藏字段或配额值推断是否子资源计价（输入/输出 Token） */
export function deriveMsUseSubResourcePricing(params: {
  useSubResourcePricing?: unknown;
  billingTotalTokens?: unknown;
  inputTokens?: unknown;
  outputTokens?: unknown;
}): boolean | undefined {
  if (typeof params.useSubResourcePricing === 'boolean') {
    return params.useSubResourcePricing;
  }
  if (hasPositiveNumber(params.billingTotalTokens)) return false;
  if (hasPositiveNumber(params.inputTokens) || hasPositiveNumber(params.outputTokens)) return true;
  return undefined;
}
